import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { useHomePageOnboardContext } from '../../../../home-page-onboard-context';

import { messages } from '../../messages';

export const ShipFromCardBody = () => {
  const { isShipFromComplete, connectedShipFromsData } = useHomePageOnboardContext();
  const { connectedDescription } = connectedShipFromsData[0] || {};

  const address = connectedDescription?.values || {};
  let displayAddress = `${address?.line1},`;
  if (address?.line2) {
    displayAddress += ` ${address.line2},`;
  }
  displayAddress += ` ${address.city}, ${address.state} ${address.postal}`;
  return isShipFromComplete ? (
    <Text shouldTruncate textType={TextType.Paragraph} value={displayAddress} />
  ) : (
    <Text textType={TextType.Paragraph} value={messages.shipFromGuidingText} />
  );
};
